import config, { axiosInstance } from '../../../_config/global';
import { hideAlert, showAlert } from '../../../components/alert/Alert';
import { AlertTypeEnum } from '../../../enums';
import { IGetSingleArgs } from '../../../interfaces';
import { ISubscriptionTiers } from '../types';

interface ISubscriptions {
  _id: string;
  tier: string;
  flight_search_limit: number;
  hotel_search_limit: number;
}

export const getSubscriptions = async () => {
  try {
    const { data } = await axiosInstance.get(
      config.endpoints.Subscriptions.subscription
    );

    return {
      ...data,
      data: data.data?.map((subscription: ISubscriptions) => ({
        _id: subscription?._id,
        tier:
          subscription?.tier?.charAt(0)?.toUpperCase() +
          subscription?.tier?.slice(1),
        hotelSearchLimit: data.data.hotel_search_limit,
        flightSearchLimit: data.data.flight_search_limit
      }))
    };
  } catch (e) {
    showAlert({
      content: 'Error fetching subscriptions',
      options: {
        actions: [{ text: 'Close', onClick: hideAlert }],
        type: AlertTypeEnum.Error
      }
    });
  }
};
export const getSingleProducts = async ({
  key
}: IGetSingleArgs): Promise<ISubscriptionTiers | void> => {
  try {
    const { data } = await axiosInstance.get(
      config.endpoints.Subscriptions.subscription + key
    );

    //if we already have a subscription, we will return that instead of the product
    return {
      _id: data.data._id,
      tier: data.data.tier?.charAt(0)?.toUpperCase() + data.data.tier?.slice(1),
      hotelSearchLimit: data.data.hotel_search_limit,
      flightSearchLimit: data.data.flight_search_limit
    };
  } catch (e) {
    showAlert({
      content: 'Error fetching subscription',
      options: {
        actions: [{ text: 'Close', onClick: hideAlert }],
        type: AlertTypeEnum.Error
      }
    });
  }
};

export const updateSubscription = async (item: ISubscriptions) => {
  try {
    await axiosInstance.put(
      config.endpoints.Subscriptions.subscription + item._id,
      item
    );

    showAlert({
      content: 'Subscription updated',
      options: {
        actions: [{ text: 'Close', onClick: hideAlert }],
        type: AlertTypeEnum.Info
      }
    });
    return;
  } catch (e) {
    showAlert({
      content: 'Error updating subscription',
      options: {
        actions: [{ text: 'Close', onClick: hideAlert }],
        type: AlertTypeEnum.Error
      }
    });
  }
};
